import { ProductQty, SelectedItemMap } from '@common/models';
import { productQtyFromSelectedItems } from '@common/utils/productQtyFromSelectedItems';

export const getPlumbingProductQty = (plumbing: SelectedItemMap): ProductQty[] => productQtyFromSelectedItems(plumbing);
